import { Box, Typography, useTheme, Button} from "@mui/material";
import { tokens } from "../../theme";
import { useNavigate } from "react-router-dom";

const RankingPage = () => {
    const theme = useTheme();
	const colors = tokens(theme.palette.mode);

    const navigate = useNavigate();

    const handlerBack = () => {
		navigate("/");
	};

    return (
        <Box
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            flexDirection: 'column',
        }}
        >
            <Typography variant="h1" color={colors.redAccent[300]}>404 - Page Not Found</Typography>
            <Typography variant="h4" color={colors.yellow[600]}>Desculpe, a Página que você está procurando não pode ser encontrada.</Typography>
            <Button
				onClick={handlerBack}
				type="submit"
				sx={{
					backgroundColor: colors.blueAccent[600],
					borderRadius: "60px",
                    marginTop: "20px"
				}}
				variant="contained"
			>
				Voltar para Home
			</Button>
        </Box>
    );

}

export default RankingPage;